import {gql} from '@apollo/client';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import ExcludeInaccessible from 'graphql-client/ExcludeInaccessible';
import {isInaccessible} from 'graphql-client/InaccessibleInfo';
import {BlobLinkList} from 'notebook/data-tables/BlobLinkList';
import {ChipSize} from 'ui-library/chips/Chip';
import LoadingChip from 'ui-library/chips/LoadingChip';
import NoAccessChip from 'ui-library/chips/NoAccessChip';

import {GetResultBlobs, GetResultBlobsVariables} from './__generated/GetResultBlobs';

type ResultBlobGQL = ExcludeInaccessible<GetResultBlobs['resultBlobs'][number]>;

export const BLOB_QUERY = gql`
  query GetResultBlobs($ids: [StrictString!]!) @skipAudit @engComponent(name: INSIGHTS) {
    resultBlobs(ids: $ids) {
      ... on ResultBlobNode {
        id
        name
        url
        previewFileJson
        pdfPreviewFileJson
        uploadStatus
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

interface QueryingBlobLinkListProps {
  blobIds: Array<string>;
  chipSize?: ChipSize;
}

function QueryingBlobLinkList({blobIds, chipSize = ChipSize.SMALL}: QueryingBlobLinkListProps): JSX.Element {
  return (
    <BenchlingQuery<GetResultBlobs, GetResultBlobsVariables>
      query={BLOB_QUERY}
      variables={{ids: blobIds}}
      renderLoading={() => (
        <>
          {blobIds.map((blobId, index) => (
            <span key={`${blobId}-${index}`}>
              <LoadingChip size={chipSize} />
            </span>
          ))}
        </>
      )}
    >
      {(data) =>
        data.resultBlobs.some((blob) => isInaccessible(blob)) ? (
          <NoAccessChip size={chipSize} />
        ) : (
          <BlobLinkList
            blobs={data.resultBlobs as Array<ResultBlobGQL>}
            chipSize={chipSize}
            blobClassName={css(styles.blobLink)}
          />
        )
      }
    </BenchlingQuery>
  );
}

const styles = StyleSheet.create({
  blobLink: {
    width: 200,
  },
});

export default QueryingBlobLinkList;
